import React, { Component } from 'react';
import {
  Button,
  Modal,
  Row,
  Col,
  Label,
} from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import _ from "underscore";

import OrdersActionCreators from '../../../actions/OrdersActionCreators';

const RemoveShipmentModal = (props) => {
  const { t } = useTranslation();
  return (
    <Modal show={props.show} bsSize="sm">
      <Modal.Header >
        <Modal.Title>{t('REMOVE_SHIPMENT_ORDER')}</Modal.Title>
      </Modal.Header>
      <Modal.Footer>
        <Row>
          <Col xs={5}></Col>
          <Col xs={7}>
            <div className="flex flex-row">
              <button
                className="button button-green hover:bg-green-dark text-white mr-2"
                onClick={() => {
                  let updatedStaging = props.order.shipments_staging.slice();
                  const stagingToRemove = _.findWhere(props.order.shipments_staging, { _id: props._id });
                  if(stagingToRemove){
                    const idx = _.indexOf(props.order.shipments_staging, stagingToRemove);
                    updatedStaging = [...updatedStaging.slice(0, idx), ...updatedStaging.slice(idx+1)];
                  }
                  OrdersActionCreators.updateOrder(props.order._id, { shipments_staging: updatedStaging });
                  props.onClose();
                }}
              >
                {t('CONFIRM')}
              </button>
              <button
                className="button bg-white text-grey hover:text-grey-darker"
                onClick={() => {
                  props.onClose();
                }}
              >
                {t('CANCEL')}
              </button>
            </div>
          </Col>
        </Row>
      </Modal.Footer>
    </Modal>
  );
}

export default RemoveShipmentModal;
